<form [formGroup]="facturacionForm" (ngSubmit)="factura()">
    <mat-form-field *ngIf="active == 0" class="col-12 padding-element" appearance="fill">
        <mat-label>Nombre</mat-label>
        <input matInput placeholder="Juan Perez"
                formControlName="nombre" #nombre
                (input)="nombre.value=$event.target.value.toUpperCase()"
        >
        <mat-error *ngIf="facturacionForm.controls['nombre'].errors?.pattern">
                Solo se permiten caracteres de texto.
        </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="active == 1" class="col-12 padding-element" appearance="fill">
        <mat-label>Razón social</mat-label>
        <input matInput placeholder="Plusbarrent S.A. de C.V."
            formControlName="razon_social" #razonSocial
            (input)="razonSocial.value=$event.target.value.toUpperCase()"
        >
        <mat-error *ngIf="facturacionForm.controls['razon_social'].errors?.pattern">
            Solo se permiten caracteres de texto.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-icon matPrefix>vpn_key</mat-icon>
        <mat-label>RFC</mat-label>
        <input matInput placeholder="5555555555"
               #rfc formControlName="rfc"
               (input)="rfc.value=$event.target.value.toUpperCase()"
        >
    </mat-form-field>

    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-icon matPrefix>phone</mat-icon>
        <mat-label>Télefono</mat-label>
        <input matInput placeholder="5555555555"
               formControlName="telefono"
        >
        <mat-error *ngIf="facturacionForm.controls['telefono'].errors?.required &&
                      facturacionForm.controls['telefono'].touched">
                      Este campo es requerido
        </mat-error>
        <mat-error 
               *ngIf="facturacionForm.controls['telefono'].errors?.pattern">
               Solo se permiten números y debén de ser 10 digitos.
        </mat-error>
    </mat-form-field>
    <mat-label class="col-12 padding-element">Domicilio</mat-label> <br>
    <mat-form-field class="col-12 col-md-4 padding-element" appearance="fill">
        <mat-label>Código Postal</mat-label>
        <input  matInput placeholder="16610" maxlength="5" formControlName="cp" (blur)="buscaCP()">
        <mat-error *ngIf="facturacionForm.controls['cp'].errors?.required &&
            facturacionForm.controls['cp'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['cp'].errors?.pattern">
            Solo se permiten números y deben de ser 5 dígitos.
        </mat-error>
        <ng-container *ngIf="cpValido == '0'">
            <small style="color: red;">
                El código postal no existe, por favor inténtalo de nuevo.
            </small>
        </ng-container>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-12 col-md-4 padding-element">
        <mat-label>Entidad Federativa</mat-label>
        <input matInput formControlName="entidad">
        <mat-error *ngIf="facturacionForm.controls['entidad'].errors?.required &&
                      facturacionForm.controls['entidad'].touched">
            Este campo es requerido
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-12 col-md-4 padding-element">
        <mat-label>Municipio</mat-label>
        <input matInput formControlName="municipio">
        <mat-error *ngIf="facturacionForm.controls['municipio'].errors?.required &&
                      facturacionForm.controls['municipio'].touched">
            Este campo es requerido
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-4 padding-element" appearance="fill">
        <mat-icon matPrefix>home</mat-icon>
        <mat-label>Colonia</mat-label>
        <mat-select formControlName="colonia">
            <mat-option *ngFor="let c of colonia" [value]="c.id"> {{ c.colonia | uppercase }} </mat-option>
        </mat-select>
        <mat-error *ngIf="facturacionForm.controls['colonia'].errors?.required &&
                      facturacionForm.controls['colonia'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error 
               *ngIf="facturacionForm.controls['colonia'].errors?.pattern">
            Solo se permiten caracteres de texto.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-4 padding-element" appearance="fill">
        <mat-icon matPrefix>room</mat-icon>
        <mat-label>Calle</mat-label>
        <input matInput placeholder="Muyuguarda"
               formControlName="calle"
               #calle
               (input)="calle.value=$event.target.value.toUpperCase()"
        >
        <mat-error *ngIf="facturacionForm.controls['calle'].errors?.required &&
                      facturacionForm.controls['calle'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['calle'].errors?.pattern">
            Solo se permiten caracteres de texto y números.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-6 col-md-2 padding-element" appearance="fill">
        <mat-label>No. Ext</mat-label>
        <input matInput placeholder="16" formControlName="num_ext">
        <mat-error *ngIf="facturacionForm.controls['num_ext'].errors?.required &&
                      facturacionForm.controls['num_ext'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['num_ext'].errors?.pattern">
            Solo se permiten números.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-6 col-md-2 padding-element" appearance="fill">
        <mat-label>No. Int</mat-label>
        <input matInput placeholder="156" formControlName="num_int">
        <mat-error *ngIf="facturacionForm.controls['num_int'].errors?.pattern">
            Solo se permiten números.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-label>Número de póliza*</mat-label>
        <input matInput placeholder="1320" formControlName="numPoliza">
        <mat-error *ngIf="facturacionForm.controls['numPoliza'].errors?.required &&
                      facturacionForm.controls['numPoliza'].touched">
            Este campo es requerido 
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['numPoliza'].errors?.pattern">
            Solo se permiten números (min 1 max 10).
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-label>Número de recibo*</mat-label>
        <input matInput placeholder="1320" formControlName="numRecibo">
        <mat-error *ngIf="facturacionForm.controls['numRecibo'].errors?.required &&
                      facturacionForm.controls['numRecibo'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['numRecibo'].errors?.pattern">
            Solo se permiten números (min 1 max 10).    
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-label>Formas de pago*</mat-label>
        <mat-select formControlName="forma_pago">
            <mat-option value="Efectivo"> EFECTIVO </mat-option>
            <mat-option value="Cheque nominativo"> CHEQUE NOMINATIVO </mat-option>
            <mat-option value="Transferencia electrónica de fondos"> TRANSFERENCIA ELECTRÓNICA DE FONDOS </mat-option>
            <mat-option value="Tarjeta de crédito"> TARJETA DE CRÉDITO </mat-option>
            <mat-option value="Otro"> OTRO </mat-option>
        </mat-select>
        <mat-error *ngIf="facturacionForm.controls['forma_pago'].errors?.required &&
                      facturacionForm.controls['forma_pago'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['forma_pago'].errors?.pattern">
            Solo se permiten caracteres de texto.
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-md-6 padding-element" appearance="fill">
        <mat-label>Correo*</mat-label>
        <input matInput placeholder="1320" formControlName="email">
        <mat-error *ngIf="facturacionForm.controls['email'].errors?.required &&
                      facturacionForm.controls['email'].touched">
            Este campo es requerido
        </mat-error>
        <mat-error *ngIf="facturacionForm.controls['email'].errors?.pattern">
            El formato del email es incorrecto.
        </mat-error>
    </mat-form-field>
    <div class="d-block d-md-flex">
        <div class="col-12 col-md-8"></div>
        <div class="col-12 col-md-4 mb-5 mt-3 p-1">
            <button mat-raised-button class="w-100">Enviar</button>
        </div>
    </div>
</form>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
    </symbol>
    <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
    </symbol>
    <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
    </symbol>
</svg>
<div class="alert {{mensaje.clase}}" role="alert" [ngStyle]="{display: mensaje.clase != '' ? 'block' : 'none'}">
    <div class="d-flex align-items-center">
        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" [attr.aria-label]="mensaje.icono"><use [attr.xlink:href]="mensaje.href"/></svg>
        <h4 class="alert-heading">{{mensaje.titulo}}</h4>
    </div>
    <p>{{mensaje.descripcion}}</p>
</div>

<app-bloqueo [visible]="bloquear"></app-bloqueo>